<template>
  <div class="ccui-home-index">
    <div class="emc-container">
      <div class="top-title">
        我的关注
      </div>
      <div class="focus-type-tabs">
        <span
          class="focus-type-tab"
          :class="{ active: focusType === 'goods' }"
          @click="switchFocusType('goods')"
          >关注的商品</span
        >
        <span
          class="focus-type-tab"
          :class="{ active: focusType === 'shop' }"
          @click="switchFocusType('shop')"
          >关注的店铺</span
        >
      </div>

      <!-- 关注的商品 -->
      <template v-if="focusType === 'goods'">
        <el-tabs
          v-model="activeName"
          @tab-click="handleClick"
          class="el-tabs__customize"
        >
          <el-tab-pane
            v-for="item in tabPaneMap"
            :key="item.name"
            :label="item.label"
            :name="item.name"
            lazy
          >
          </el-tab-pane>
        </el-tabs>

        <div class="top-weap">
          <div style="line-height: 30px;user-select: none;">
            <label v-if="isBatch">
              <el-checkbox
                class="emc-checkbox"
                :indeterminate="isIndeterminate"
                :value="checkAll"
                @change="handleCheckAllChange"
              ></el-checkbox>
              <span class="text">全选</span>
            </label>
          </div>
          <div class="top-weap-right">
            <el-button v-if="!isBatch" @click="batchManage(true)"
              >批量管理</el-button
            >
            <el-button v-if="isBatch" @click="batcDelete">批量删除</el-button>
            <el-button v-if="isBatch" @click="batchManage(false)"
              >取消删除</el-button
            >
            <el-input
              placeholder="请输入商品标题"
              v-model="formDataSearch.skuTitle"
              class="input-with-select"
              clearable
            >
              <el-button slot="append" @click="search">搜索</el-button>
            </el-input>
          </div>
        </div>
        <div class="shop-container">
          <ul>
            <li v-for="(item, key) in tableData" :key="key" class="shop-item">
              <shopContainer
                :goods="item"
                :isBatch="isBatch"
                @delete="handleDelete"
              />
            </li>
          </ul>
        </div>
        <div
          class="ccui-table-footer"
          style="overflow: hidden;"
          v-if="tableData.length > 0"
        >
          <div id="ccui-paging">
            <el-pagination
              :total="totalNum"
              :page-size="pageSizeCode"
              :current-page="pageNoCode"
              :page-sizes="[5, 10, 20, 50, 100, 200, 500]"
              background
              layout="total, sizes, prev, pager, next, jumper"
              popper-class="ccui-paging-page-size-popper"
              @prev-click="handlePrev"
              @next-click="handleNext"
              @size-change="handleSizeChange"
              @current-change="handleCurrentChange"
            />
            <el-button
              class="ccui-pagination-btn"
              size="mini"
              type="default"
              @click="handleSizeChange('none')"
              >确定</el-button
            >
          </div>
        </div>
        <div
          v-else
          style="text-align: center;margin-top: 50px;font-size: 14px;color: #999;"
        >
          暂无数据
        </div>
      </template>

      <!-- 关注的店铺 -->
      <template v-if="focusType === 'shop'">
        <el-tabs
          v-model="shopActiveName"
          @tab-click="handleShopTabClick"
          class="el-tabs__customize"
        >
          <el-tab-pane
            v-for="item in shopTabPaneMap"
            :key="item.name"
            :label="item.label"
            :name="item.name"
            lazy
          >
          </el-tab-pane>
        </el-tabs>

        <div class="top-weap">
          <div style="line-height: 30px;user-select: none;">
            <label v-if="isShopBatch">
              <el-checkbox
                class="emc-checkbox"
                :value="shopCheckAll"
                @change="handleShopCheckAllChange"
              ></el-checkbox>
              <span class="text">全选</span>
            </label>
          </div>
          <div class="top-weap-right">
            <el-button v-if="!isShopBatch" @click="shopBatchManage(true)"
              >批量管理</el-button
            >
            <el-button v-if="isShopBatch" @click="shopBatchDelete"
              >批量删除</el-button
            >
            <el-button v-if="isShopBatch" @click="shopBatchManage(false)"
              >取消删除</el-button
            >
            <el-select
              v-model="shopSearch.businessCategory"
              placeholder="经营类别"
              clearable
              class="business-category-select"
              @change="shopSearchChange"
            >
              <el-option
                v-for="item in businessCategoryOptions"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              ></el-option>
            </el-select>
            <el-input
              placeholder="请输入店铺名称"
              v-model="shopSearch.shopName"
              class="input-with-select"
              clearable
            >
              <el-button slot="append" @click="shopSearchSubmit"
                >搜索</el-button
              >
            </el-input>
          </div>
        </div>
        <div class="shop-container" v-loading="shopLoading">
          <ul>
            <li
              v-for="(item, key) in shopTableData"
              :key="key"
              class="shop-item"
            >
              <shopFocusContainer
                :goods="item"
                :isBatch="isShopBatch"
                @delete="handleShopDelete"
              />
            </li>
          </ul>
        </div>
        <div
          class="ccui-table-footer"
          style="overflow: hidden;"
          v-if="shopTableData.length > 0"
        >
          <div id="ccui-paging">
            <el-pagination
              :total="shopTotalNum"
              :page-size="shopPageSize"
              :current-page="shopPageNo"
              :page-sizes="[5, 10, 20, 50, 100, 200, 500]"
              background
              layout="total, sizes, prev, pager, next, jumper"
              popper-class="ccui-paging-page-size-popper"
              @size-change="handleShopSizeChange"
              @current-change="handleShopCurrentChange"
            />
            <el-button
              class="ccui-pagination-btn"
              size="mini"
              type="default"
              @click="handleShopSizeChange('none')"
              >确定</el-button
            >
          </div>
        </div>
        <div
          v-else
          style="text-align: center;margin-top: 50px;font-size: 14px;color: #999;"
        >
          暂无数据
        </div>
      </template>
    </div>
  </div>
</template>

<script>
import shopContainer from "./components/shopContainer.vue";
import shopFocusContainer from "./components/shopFocusContainer.vue";
import {
  getFocusSkuPageList,
  deleteFocusSkuInfo,
  deleteShopFocus,
  qryShopFocusPage,
  batchDeleteShopFocus
} from "@/api/emc-api";
export default {
  name: "ListContainer",
  data() {
    return {
      focusType: "goods",
      activeName: "1",
      tabPaneMap: [
        { name: "1", label: "全部" },
        { name: "2", label: "有货商品" },
        { name: "3", label: "无货商品" },
        { name: "4", label: "下架商品" },
        { name: "5", label: "30天前加购" }
      ],
      isBatch: false,
      totalNum: 0,
      pageSizeCode: 10,
      pageNoCode: 1,
      formDataSearch: {
        skuTitle: ""
      },
      tableData: [],
      // 店铺关注
      isShopBatch: false,
      shopTotalNum: 0,
      shopPageSize: 10,
      shopPageNo: 1,
      shopSearch: {
        shopName: "",
        shopStatus: "",
        businessCategory: ""
      },
      businessCategoryOptions: [
        { label: "办公用品", value: "办公用品" },
        { label: "工业品", value: "工业品" },
        { label: "工业品,办公用品", value: "工业品,办公用品" }
      ],
      shopActiveName: "1",
      shopTabPaneMap: [
        { name: "1", label: "全部" },
        { name: "2", label: "已闭店" }
      ],
      shopTableData: [],
      shopLoading: false
    };
  },

  components: {
    shopContainer,
    shopFocusContainer
  },

  computed: {
    isIndeterminate() {
      const selectedItems = this.tableData.filter(item => item.isSelected);
      return (
        selectedItems.length > 0 && selectedItems.length < this.tableData.length
      );
    },
    checkAll() {
      return (
        this.tableData.length > 0 &&
        this.tableData.every(item => item.isSelected)
      );
    },
    shopCheckAll() {
      return (
        this.shopTableData.length > 0 &&
        this.shopTableData.every(item => item.isSelected)
      );
    }
  },

  created() {
    document.title = "我的关注 - 中交云采";
    this.init();
  },

  methods: {
    switchFocusType(type) {
      this.focusType = type;
      if (type === "goods") {
        this.init();
      } else {
        this.initShopList();
      }
    },
    // ===== 商品关注 =====
    init() {
      this.isBatch = false;
      this.getList({});
    },
    handleClick(tab) {
      this.pageNoCode = 1;
      this.tableData = [];
      this.init();
    },
    handleDelete(row) {
      this.deleteFocusSkuInfo([row.skuId]);
    },
    deleteFocusSkuInfo(skuIds) {
      deleteFocusSkuInfo({ skuIds: skuIds })
        .then(res => {
          if (res.data.code == "0") {
            this.$message({
              message: res.data.message,
              type: "success",
              showClose: true,
              ccuiCustom: true
            });
            this.init();
          }
        })
        .catch(err => {});
    },
    search() {
      this.pageNoCode = 1;
      this.getList(this.formDataSearch);
    },
    getList(reqObj) {
      let obj = {};
      obj = typeof reqObj == "object" ? reqObj : obj;
      obj = JSON.parse(JSON.stringify(obj));
      obj.pageNo = this.pageNoCode;
      obj.pageSize = this.pageSizeCode;
      getFocusSkuPageList({
        ...obj,
        searchType: this.activeName,
        isShowPageLoading: true
      })
        .then(res => {
          this.tableData = res.data.data.rows.map(v => {
            v.isSelected = false;
            return v;
          });
          this.totalNum = res.data.data.recordsTotal;
          this.total = res.data.data.recordsTotal;
          this.pageNoCode = res.data.data.pageNo;
        })
        .catch(err => {});
    },
    handleCheckAllChange(value) {
      this.tableData = this.tableData.map(v => {
        v.isSelected = value;
        return v;
      });
    },
    batcDelete() {
      const skuIds = this.tableData
        .filter(item => item.isSelected)
        .map(item => item.skuId);
      if (skuIds.length == 0) {
        return this.$message({
          message: "请选中商品，再删除！",
          type: "error",
          showClose: true,
          ccuiCustom: true
        });
      }
      this.$confirm("确认删除已关注的商品吗？", "提示", {
        distinguishCancelAndClose: true,
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        customClass: "ccui-message-box-custom"
      })
        .then(() => {
          this.deleteFocusSkuInfo(skuIds);
        })
        .catch(() => {});
    },
    handlePrev() {},
    handleNext() {},
    handleSizeChange(val) {
      this.pageNoCode = 1;
      if (val !== "none") {
        this.pageSizeCode = val;
      }
      this.getList(this.formDataSearch);
    },
    handleCurrentChange(val) {
      this.pageNoCode = val;
      this.getList(this.formDataSearch);
    },
    batchManage(val) {
      this.isBatch = val;
      this.tableData = this.tableData.map(v => {
        v.isSelected = false;
        return v;
      });
    },
    // ===== 店铺关注 =====
    initShopList() {
      this.isShopBatch = false;
      this.shopActiveName = "1";
      this.shopSearch.shopStatus = "";
      this.shopSearch.businessCategory = "";
      this.getShopList();
    },
    handleShopTabClick(tab) {
      this.shopPageNo = 1;
      this.shopTableData = [];
      // 根据页签设置 shopStatus 参数
      if (tab.name === "2") {
        this.shopSearch.shopStatus = 1; // 已闭店
      } else {
        this.shopSearch.shopStatus = ""; // 全部
      }
      this.getShopList();
    },
    getShopList() {
      this.shopLoading = true;
      const params = {
        pageNum: this.shopPageNo,
        pageSize: this.shopPageSize
      };
      if (this.shopSearch.shopName) {
        params.shopName = this.shopSearch.shopName;
      }
      if (
        this.shopSearch.shopStatus !== "" &&
        this.shopSearch.shopStatus !== null
      ) {
        params.shopStatus = this.shopSearch.shopStatus;
      }
      if (this.shopSearch.businessCategory) {
        params.businessCategory = this.shopSearch.businessCategory;
      }
      qryShopFocusPage(params)
        .then(res => {
          if (res.data.code == "0") {
            this.shopTableData = (res.data.data.rows || []).map(v => {
              v.isSelected = false;
              return v;
            });
            this.shopTotalNum = res.data.data.recordsTotal || 0;
          }
        })
        .catch(err => {})
        .finally(() => {
          this.shopLoading = false;
        });
    },
    shopSearchChange() {
      this.shopPageNo = 1;
      this.getShopList();
    },
    shopSearchSubmit() {
      this.shopPageNo = 1;
      this.getShopList();
    },
    handleShopSizeChange(val) {
      this.shopPageNo = 1;
      if (val !== "none") {
        this.shopPageSize = val;
      }
      this.getShopList();
    },
    handleShopCurrentChange(val) {
      this.shopPageNo = val;
      this.getShopList();
    },
    handleShopDelete(row) {
      this.$confirm("确认取消关注该店铺吗？", "提示", {
        distinguishCancelAndClose: true,
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        customClass: "ccui-message-box-custom"
      })
        .then(() => {
          deleteShopFocus({ shopId: row.shopId })
            .then(res => {
              if (res.data.code == "0") {
                this.$message({
                  message: "已取消关注",
                  type: "success",
                  showClose: true,
                  ccuiCustom: true
                });
                this.getShopList();
              }
            })
            .catch(err => {});
        })
        .catch(() => {});
    },
    handleShopCheckAllChange(value) {
      // 批量删除只能全选，不能选多个店铺
      this.shopTableData = this.shopTableData.map(v => {
        v.isSelected = value;
        return v;
      });
    },
    shopBatchManage(val) {
      this.isShopBatch = val;
      this.shopTableData = this.shopTableData.map(v => {
        v.isSelected = false;
        return v;
      });
    },
    shopBatchDelete() {
      const ids = this.shopTableData
        .filter(item => item.isSelected)
        .map(item => item.id);
      if (ids.length == 0) {
        return this.$message({
          message: "请选中店铺，再删除！",
          type: "error",
          showClose: true,
          ccuiCustom: true
        });
      }
      this.$confirm("确认取消关注已选中的店铺吗？", "提示", {
        distinguishCancelAndClose: true,
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        customClass: "ccui-message-box-custom"
      })
        .then(() => {
          batchDeleteShopFocus({ ids })
            .then(res => {
              if (res.data.code == "0") {
                this.$message({
                  message: "已批量取消关注",
                  type: "success",
                  showClose: true,
                  ccuiCustom: true
                });
                this.getShopList();
              }
            })
            .catch(err => {});
        })
        .catch(() => {});
    }
  },

  watch: {}
};
</script>
<style lang="scss" scoped>
.emc-container {
  min-height: 600px;
}
.focus-type-tabs {
  display: flex;
  margin-top: 15px;
  border-bottom: 2px solid #f1f1f1;
  .focus-type-tab {
    padding: 10px 20px;
    font-family: PingFangSC, PingFang SC;
    font-weight: 400;
    font-size: 16px;
    color: #666;
    cursor: pointer;
    position: relative;
    &.active {
      color: #ff142f;
      font-weight: 500;
      &::after {
        content: "";
        position: absolute;
        left: 0;
        bottom: -2px;
        width: 100%;
        height: 2px;
        background-color: #ff142f;
      }
    }
  }
}
.top-weap {
  display: flex;
  justify-content: space-between;
  margin-top: 15px;
  .text {
    font-family: PingFangSC, PingFang SC;
    font-weight: 400;
    font-size: 14px;
    color: #4a4a4a;
    line-height: 20px;
    text-align: left;
    font-style: normal;
  }
  .el-checkbox {
    margin-right: 10px;
    margin-left: 0;
  }
  .top-weap-right {
    display: flex;
    align-items: center;
    .business-category-select {
      width: 160px;
      margin-left: 10px;
      /deep/ .el-input__inner {
        border-color: #ff142f !important;
        border-radius: 0px;
        height: 30px;
        line-height: 30px;
      }
    }
    .input-with-select {
      width: 300px;
      height: 30px;
      margin-left: 10px;
      /deep/.el-input-group__append {
        border: none;
      }
      /deep/ .el-input__inner {
        border-color: #ff142f !important;
        border-radius: 0px;
        margin-top: 1px;
      }
      .el-button {
        border-radius: 0px;
        span {
          font-family: PingFangSC, PingFang SC;
          font-weight: 400;
          font-size: 13px;
          color: #ffffff;
          line-height: 18px;
          text-align: left;
        }
      }
      .el-input-group__append button.el-button,
      .el-input-group__append div.el-select .el-input__inner,
      .el-input-group__append div.el-select:hover .el-input__inner,
      .el-input-group__prepend button.el-button,
      .el-input-group__prepend div.el-select .el-input__inner,
      .el-input-group__prepend div.el-select:hover .el-input__inner {
        background-color: #ff142f !important;
        color: #ffffff;
      }
    }
  }
}
.shop-container {
  margin-top: 15px;
  ul {
    display: flex;
    flex-wrap: wrap;
    li {
      margin-bottom: 10px;
      width: calc(20% - 8px);
    }
  }
}
.shop-footer {
  display: flex;
  justify-content: end;
  width: 100%;
  margin-top: 40px;
}
.top-title {
  font-size: 16px;
  color: #4a4a4a;
  font-weight: bold;
}
/deep/ .el-tabs__customize {
  margin-top: 15px;
  .el-tabs__nav-wrap {
    .el-tabs__item:not(.is-active) {
      font-weight: normal;
    }
    &:after {
      content: "";
      position: absolute;
      left: 0;
      bottom: 0;
      width: 100%;
      height: 2px;
      background-color: #f1f1f1;
      z-index: 1;
    }
  }
}
.shop-item {
  margin-right: 10px;
  &:nth-of-type(5n) {
    margin-right: 0;
  }
}
/deep/.el-checkbox__inner {
  width: 20px;
  height: 20px;
}
/deep/.el-checkbox__inner::after {
  border-width: 2px;
  height: 12px;
  width: 6px;
  left: 5px;
}
/deep/.el-checkbox__input.is-indeterminate .el-checkbox__inner::before {
  height: 2px;
  left: 3px;
  right: 3px;
  top: 8px;
  transform: scale(1);
}
</style>
